import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from '@shared/components/Layout';
import SellerMainPage from '@pages/SellerMainPage';
import {
  ProductsPage,
  ProductPage,
  CreateProductPage,
  EditProductPage,
  ExtrasPage,
  BonusesPage,
  ContactsPage,
  PickupPointDetailsPage,
  OrdersPage,
  OrderDetailsPage,
  ReviewsPage,
  PromoCodesPage,
  TbankTestPage,
  SellerProfilePage,
  SellerSalesPage,
  SellerFinancePage,
  SellerOnboardingPage,
  SellerAccessesPage,
  SellerPromotionPage,
  SellerSupportChatPage,
  SellerOrderChatsPage,
  NotFoundPage,
} from '@pages';

/** Те же экраны и вложенность, что в admin, внутри общего Layout. */
export default function SellerApprovedRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<SellerMainPage />} />
        <Route path="onboarding" element={<SellerOnboardingPage />} />
        <Route path="profile" element={<SellerProfilePage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="products/new" element={<CreateProductPage />} />
        <Route path="products/:productId/edit" element={<EditProductPage />} />
        <Route path="products/:productId" element={<ProductPage />} />
        <Route path="extras" element={<ExtrasPage />} />
        <Route path="promotion" element={<SellerPromotionPage />} />
        <Route path="bonuses" element={<BonusesPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="sales" element={<SellerSalesPage />} />
        <Route path="finance" element={<SellerFinancePage />} />
        <Route path="orders/:id" element={<OrderDetailsPage />} />
        <Route path="deliveries" element={<Navigate to="/orders" replace />} />
        <Route path="reviews" element={<ReviewsPage />} />
        <Route path="promo-codes" element={<PromoCodesPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="contacts/pickup-points/:id" element={<PickupPointDetailsPage />} />
        <Route path="accesses" element={<SellerAccessesPage />} />
        <Route path="support-chat" element={<SellerSupportChatPage />} />
        <Route path="order-chats" element={<SellerOrderChatsPage />} />
        <Route path="tbank-test" element={<TbankTestPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
